import React, { ComponentType, ReactNode } from 'react';
import { styled } from '@mui/material';
import Button, { CustomButtonProps } from './Button';

type Props = {
  icon?: ReactNode,
} & Omit<CustomButtonProps, "variant">;

const BlueButtonWithIcon: ComponentType<CustomButtonProps> = styled(Button)({
  gap: '8px',
  minWidth: 'unset',
  borderRadius: '5px',
  height: '32px',
  backgroundColor: '#0052CC',
  color: 'white',
  cursor: 'pointer',
  fontSize: '20px',
  '&>svg': {
    height: '20px',
    width: '20px',
  }
});

const TitleOfBlueButtonWithIcon = styled('span')({
  height: '16px',
  fontSize: '14px',
  fontWeight: '500',
  lineHeight: '16.41px',
  letterSpacing: '-0.02em',
  textAlign: 'right'
});

export default ({ icon, children, ...props }: Props) => {
  return <BlueButtonWithIcon
    style={{ padding: icon ? '6px 12px 6px 10px' : '6px 12px' }}
    {...props}
    variant="contained"
  >
    {icon}
    <TitleOfBlueButtonWithIcon>{children}</TitleOfBlueButtonWithIcon>
  </BlueButtonWithIcon>
};